import queryString from "query-string";
import { useLocation } from "react-router-dom";

const useURLParams = () => {
  const location = useLocation();
  const { search } = location; // 문자열 형식으로 결과값이 반환된다.
  const queryObj = queryString.parse(search); // 문자열의 쿼리스트링을 Object로 변환

  const get = (key) => {
    return queryObj[key];
  };

  return { getParam: get };
};

export default useURLParams;
